(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3422],{

/***/ 98504:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/article/[...all]",
      function () {
        return __webpack_require__(88343);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60898);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25935);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14416);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60306);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_Article_Article_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54510);
/* harmony import */ var _components_Article_Article_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_components_Article_Article_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Layout_Layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24987);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_9__);












var CallToSignUp = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8307), __webpack_require__.e(8746)]).then(__webpack_require__.bind(__webpack_require__, 68307));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68307)
            ];
        }
    }
});
var SocialMediaLinks = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 7401).then(__webpack_require__.bind(__webpack_require__, 17401));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17401)
            ];
        }
    }
});
var RecommendationsList = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 9972).then(__webpack_require__.bind(__webpack_require__, 39972));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39972)
            ];
        }
    }
});
function ArchiveArticle(param) {
    var article = param.article, recommendation = param.recommendation, authCompleted = param.authCompleted;
    var ref, ref1;
    var userStore = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return state.user.value;
    });
    var root = (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(article.content, {
        replace: function(domNode) {
            // generation link, removing everything before /wp-content
            if (domNode.type === "tag" && domNode.name === "img") {
                return domNode.parent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_components_Article_Article_module_scss__WEBPACK_IMPORTED_MODULE_10___default().imageInline),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__/* .ImageWithFallback */ .JG, {
                            src: "https://media.first-class.com/" + domNode.attribs.src.substring(domNode.attribs.src.lastIndexOf("/wp-content") + 1),
                            layout: "fill",
                            objectFit: "cover"
                        })
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_components_Article_Article_module_scss__WEBPACK_IMPORTED_MODULE_10___default().imageInline),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__/* .ImageWithFallback */ .JG, {
                        src: "https://media.first-class.com/" + domNode.attribs.src.substring(domNode.attribs.src.lastIndexOf("/wp-content") + 1),
                        layout: "fill",
                        objectFit: "cover"
                    })
                });
            }
            if (domNode.name === "p" && domNode.children[0] && domNode.children[0].name === "img") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_components_Article_Article_module_scss__WEBPACK_IMPORTED_MODULE_10___default().imageInline),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__/* .ImageWithFallback */ .JG, {
                        src: "https://media.first-class.com/" + domNode.children[0].attribs.src.substring(domNode.children[0].attribs.src.lastIndexOf("/wp-content") + 1),
                        layout: "fill",
                        objectFit: "cover"
                    })
                });
            }
            // [caption] replacement
            if (domNode.type === "text") {
                if (domNode.parent && domNode.parent.name === "p" || domNode.parent && domNode.parent.parent && domNode.parent.parent.name === "p") {
                    return;
                }
                domNode.data = domNode.data.replace(new RegExp(/\[.+\]/g), "");
                return domNode.parent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-justify",
                    dangerouslySetInnerHTML: {
                        __html: "<".concat(domNode.parent.name, ">").concat(domNode.data, "</").concat(domNode.parent.name, ">")
                    }
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-justify",
                    children: domNode.data
                });
            }
        }
    });
    var metaDescription = "";
    var parseTextFromNode = function(node) {
        if (typeof node !== "string") {
            if (node && Array.isArray(node.props.children)) {
                node.props.children.forEach(function(child) {
                    parseTextFromNode(child);
                });
            } else if (node) {
                parseTextFromNode(node.props.children);
            }
        } else {
            metaDescription += node;
        }
    };
    parseTextFromNode(root[0]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_9___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                        children: [
                            article.title,
                            " - First-Class.com"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "first-class.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: article.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://media.first-class.com/" + article.image
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: article.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://media.first-class.com/" + article.image
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("container font-libre"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_components_Article_Article_module_scss__WEBPACK_IMPORTED_MODULE_10___default().article),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_components_Article_Article_module_scss__WEBPACK_IMPORTED_MODULE_10___default().overline),
                            children: article.overline
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_components_Article_Article_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title), "font-fragment"),
                            dangerouslySetInnerHTML: {
                                __html: article.title
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-center",
                            children: moment__WEBPACK_IMPORTED_MODULE_7___default()(article.published).format("D. MMM yyyy")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "text-center mb-7",
                            children: [
                                "by ",
                                article.author
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_components_Article_Article_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mainImage),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__/* .ImageWithFallback */ .JG, {
                                src: "https://media.first-class.com/" + ((ref = article.image) === null || ref === void 0 ? void 0 : ref.substring(((ref1 = article.image) === null || ref1 === void 0 ? void 0 : ref1.lastIndexOf("/wp-content")) + 1)),
                                layout: "fill",
                                objectFit: "cover"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "content font-libre mt-4",
                            children: root
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            children: typeof document !== "undefined" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialMediaLinks, {})
                        })
                    ]
                })
            }),
            userStore && !userStore.userid && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full mx-auto my-20 sm:mb-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CallToSignUp, {
                    country: userStore === null || userStore === void 0 ? void 0 : userStore.country,
                    authCompleted: authCompleted,
                    sourcePage: "Archive article"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container flex justify-center items-center sm:w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RecommendationsList, {
                    items: recommendation
                })
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,_Layout_Layout__WEBPACK_IMPORTED_MODULE_8__/* .withLayout */ .X)(ArchiveArticle, false));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,4231,129,1979,7601,9125,6700,632,9780,6420,4987,9774,2888,179], function() { return __webpack_exec__(98504); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);